import { render, staticRenderFns } from "./WordBookDialog.vue?vue&type=template&id=277c1846&scoped=true"
import script from "./WordBookDialog.vue?vue&type=script&lang=js"
export * from "./WordBookDialog.vue?vue&type=script&lang=js"
import style0 from "./WordBookDialog.vue?vue&type=style&index=0&id=277c1846&prod&scoped=true&lang=css"
import style1 from "./WordBookDialog.vue?vue&type=style&index=1&id=277c1846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c1846",
  null
  
)

export default component.exports